import React, { useCallback, useEffect, useRef, useState } from 'react'
import { NavLink } from 'react-router-dom'
import { directLink } from '../constants/endspoints'
import { useEmissions } from '../constants/functions'
import { fetchPrograms } from '../api/programmation'
import { useInfiniteQuery } from '@tanstack/react-query'
import IsEmpty from './../components/IsEmpty';
import { format } from 'date-fns'
import { fr } from 'date-fns/locale'
import teaser_video from '../assets/videos/teaser_2023_ubiz_HD.mp4'


const Direct = () => {

    const { data: programsList, fetchNextPage, hasNextPage, isFetchingNextPage, status: listStatus } = useInfiniteQuery({
        queryKey: ["program"],
        queryFn: fetchPrograms,
        getNextPageParam: (lastPage) => lastPage.nextPage,
        retry: 2,
    });

    const observer = useRef();
    const lastMediaRef = useCallback((node) => {
        if (isFetchingNextPage) return;
        if (!hasNextPage) return;

        if (observer.current) observer.current.disconnect();

        observer.current = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                fetchNextPage(); 
            }
        });

        if (node) observer.current.observe(node);
    }, [isFetchingNextPage, hasNextPage, fetchNextPage]);


    const [emissionsData, setEmissionsData] = useState([])
    useEffect(() => {
        setEmissionsData(programsList?.pages?.flatMap((page) => page.data))
    }, [programsList]);

    const { upcomingEmissions, currentEmission } = useEmissions(emissionsData)



    return (
        <div className='text-white mb-5 container-xxl' ref={lastMediaRef}>
            <div className=' row justify-content-between align-items-start'>

                {/* Player */}
                <div className=' col-md-8 col-12 mb-md-0 mb-3'>
                    <video src={teaser_video}
                        style={{overflow:"hidden", border:"none", aspectRatio:"1.77777"}}
                        className='player-size bgcolor-secondary-25'
                        title="UBIZNEWS en Direct"
                        autoPlay={true}
                        loop={true}
                        muted={false}
                        controls={true}
                        allowFullScreen={true}
                        >
                    </video>
                    <div className='mt-3 mb-2'>
                        {
                            listStatus === 'pending' ?
                            <div className=' placeholder-wave'>
                                <h2 className='px-2 fw-bold fs-4 text-uppercase placeholder col-12 bg-white opacity-75'> </h2>
                            </div>
                            :<h2 className='border-start bordercolor-primary border-1 px-2 fw-black fs-4 text-uppercase'>{currentEmission?.name}</h2>
                        }
                    </div>
                </div>

                {/* Next to see */}
                <div className=' col-md-4 col-12'>
                    <div>
                        <h3 className='bgcolor-primary px-md-2 px-1 py-md-2 py-1 fs-5 fw-bold text-uppercase text-center'>à la une</h3>

                        {
                            listStatus === 'pending' ?
                            <div className=' mt-3 d-flex flex-column flex-wrap placeholder-wave'>
                                {
                                    [1,2,3,4,5,6].map((elt, index) =>(
                                        <div key={index} className='border-start bordercolor-primary border-1 mb-3 px-2'>
                                            <h4 className='text-truncate-1 fw-bold fs-6 mb-0 placeholder opacity-75'> </h4>
                                            <p className='mb-0 fs-7s lh-sm text-white text-opacity-75 col-12 placeholder'>{}</p>
                                        </div>
                                    ))
                                }
                            </div>
                            :upcomingEmissions.length <= 0 ?
                            <IsEmpty icon={"fa-light fa-calendar "} message={"Restez connecté"} />
                            :<div className=' mt-3 d-flex flex-column flex-wrap'>
                                {
                                    upcomingEmissions.map((emissiom, index) =>(
                                        <div key={index} className='border-start bordercolor-primary border-1 mb-3 px-2'>
                                            <text className='text-truncate-1 fw-bold fs-6'>{emissiom?.name}</text>
                                            <p className='mb-0 fs-7s lh-sm text-white text-opacity-75 text-capitalize'>{format(emissiom?.startDateTime, 'eeee, dd MMMM HH:mm', {locale: fr})}</p>
                                        </div>
                                    )).slice(0,6)
                                }
                            </div>

                        }
                        <div className='mt-3 w-100 d-flex justify-content-end'>
                            <NavLink to={`${directLink}/grille_tv`} className='border bordercolor-primary rounded-0 w-auto d-flex align-items-center text-white px-2 py-1'>
                                <span className='fs-9s me-2'>Voir plus</span>
                                <fa className='fa-regular fa-angle-right'></fa>
                            </NavLink>
                        </div> 
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Direct